import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import { SectionTitle } from "@/components/base/Rating";

export default function NewsPreview() {
  const items = newsList.slice(0, 5);
  const [lead, ...rest] = items;

  return (
    <section className="w-full px-4 md:px-6 pt-14 md:pt-20">
      <SectionTitle
        accentLabel="Editorial"
        title="影视资讯精选"
        subtitle="影评、行业观察与电影节动态，每天更新。"
        moreTo="/news"
        moreLabel="全部资讯"
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
        <Link
          to={`/news/detail/${lead.id}`}
          className="lg:col-span-6 group block rounded-lg overflow-hidden bg-background-100 border border-background-200 cursor-pointer"
        >
          <div className="w-full aspect-[16/9] overflow-hidden">
            <img
              src={lead.cover}
              alt={lead.title}
              title={`${lead.title} - CC视频资讯`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="p-4 md:p-6">
            <div className="flex items-center gap-2 mb-3">
              <span className="px-2 py-0.5 rounded text-[11px] font-medium bg-accent-100 text-accent-800">
                {lead.category}
              </span>
              <span className="text-[11px] text-foreground-500 font-label">{lead.publishedAt}</span>
            </div>
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 leading-snug group-hover:text-accent-600 transition-colors">
              {lead.title}
            </h3>
            <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed line-clamp-3-custom">
              {lead.summary}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-foreground-800">
              阅读全文
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-0.5" />
            </span>
          </div>
        </Link>

        <div className="lg:col-span-6 flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          {rest.map((n) => (
            <Link
              key={n.id}
              to={`/news/detail/${n.id}`}
              className="group flex gap-3 md:gap-4 p-3.5 md:p-4 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <div className="w-24 h-16 md:w-32 md:h-[84px] rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={n.cover}
                  alt={n.title}
                  title={`${n.title} - CC视频资讯`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                  <span className="text-accent-700 font-medium">{n.category}</span>
                  <span className="font-label">{n.publishedAt}</span>
                </div>
                <h3 className="mt-1 text-sm font-medium text-foreground-950 leading-snug line-clamp-2-custom group-hover:text-accent-600 transition-colors">
                  {n.title}
                </h3>
                <p className="hidden sm:block mt-1 text-xs text-foreground-500 line-clamp-2-custom">
                  {n.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}